module.exports = __webpack_public_path__ + "img/CameraZOOM-20211111170113102.1cd54e86.jpg";